import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-156711e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nonbid_xieyi" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " 线下签署协议请将文件发给客户经理，线上签署协议请复制对应的协议链接，用浏览器打开，按照提示完成签署即可！ ", -1))
const _hoisted_3 = { class: "table" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"tr\" data-v-156711e9><div class=\"td\" data-v-156711e9>协议名称</div><div class=\"td\" data-v-156711e9>签署状态</div><div class=\"td\" data-v-156711e9>签署方式</div><div class=\"td\" data-v-156711e9>操作</div></div><div class=\"tr\" data-v-156711e9><div class=\"td\" data-v-156711e9>委托担保协议</div><div class=\"td\" data-v-156711e9>待签署</div><div class=\"td\" data-v-156711e9>线下</div><div class=\"td\" data-v-156711e9></div></div>", 2)
const _hoisted_6 = { class: "tr" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "td" }, "征信查询函", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "td" }, "待签署", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "td" }, "线上", -1))
const _hoisted_10 = { class: "td" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_12 = { class: "tr" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "td" }, "反担保-个人", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "td" }, "待签署", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "td" }, "线上", -1))
const _hoisted_16 = { class: "td" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_18 = { class: "tr" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "td" }, "反担保-企业", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "td" }, "待签署", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "td" }, "线上", -1))
const _hoisted_22 = { class: "td" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("复制")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_van_button, {
            class: "btn",
            plain: "",
            size: "mini",
            onClick: _ctx.copy,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_van_button, {
            class: "btn",
            plain: "",
            size: "mini",
            onClick: _ctx.copy,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_van_button, {
            class: "btn",
            plain: "",
            size: "mini",
            onClick: _ctx.copy,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}